import { apiClient } from './apiClient'

export function getYardMap(facilityId: string): Promise<any> {
  return apiClient.get<any>(`/api/v1/spatial/yard-map/${facilityId}`)
}
